import { type DeckardIcon } from '@assets/icons';
import { Group } from '@components/layout';
import { Typography } from '@components/typography';
import { useTheme } from '@mui/material';

export const ServerConfigurationTab = ({
  tabState,
  value,
  label,
  Icon,
}: {
  tabState: [string, (tab: string) => void];
  value: string;
  label: string;
  Icon: DeckardIcon;
}) => {
  const { palette } = useTheme();
  const [activeTab, setActiveTab] = tabState;
  const isActive = activeTab === value;
  return (
    <Group
      role="button"
      sx={{
        backgroundColor: isActive ? (palette.primary[800] as string) : 'background.paperCard',
        color: isActive ? palette.common.white : 'foreground.paperCard.light',
        borderRadius: 1,
        cursor: 'pointer',
        pl: 2,
        pr: 4,
        py: 1,
        '&:hover': {
          backgroundColor: isActive ? (palette.primary[800] as string) : 'backgroundHover.paper',
          color: isActive ? palette.common.white : 'foreground.paperCard.default',
        },
      }}
      alignItems="center"
      gap={2}
      onClick={() => setActiveTab(value)}
    >
      <Icon size={14} />
      <Typography variant="body2">{label}</Typography>
    </Group>
  );
};
